import React from "react";
import { Form, Input, Row, Col, Select, Divider, Typography } from "antd";
import "./user.css";

const { TextArea } = Input;
const { Text } = Typography;
class MemberDetail extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    userDetail: {},
    countryList: [],
    adminList: [],
  };

  async componentDidMount() {
    const { countryList, adminList, isAddUser } = this.props;
    countryList.shift();
    await this.setState({
      userDetail: this.props.detail,
      countryList,
      adminList,
    });
    this.setFieldsValue(isAddUser ? {} : this.props.detail); // Set initial values based on isAddUser
  }

  componentDidUpdate(prevProps) {
    if (this.props.isModalVisible && !prevProps.isModalVisible) {
      this.setFieldsValue(this.props.isAddUser ? {} : this.props.detail); // Set initial values based on isAddUser
    }
  }

  setFieldsValue = (initialValues) => {
    const is_postpaid = initialValues.is_postpaid;
    const payment_term = initialValues.payment_term
      ? initialValues.payment_term
      : undefined;
    const min_balance_allowed = initialValues.min_balance_allowed
      ? initialValues.min_balance_allowed
      : undefined;

    this.props.form.setFieldsValue({
      email: initialValues.email,
      firstname: initialValues.firstname,
      lastname: initialValues.lastname,
      tel: initialValues.tel,
      company_name: initialValues.company_name,
      address: initialValues.address,
      city: initialValues.city,
      state: initialValues.state,
      zip_code: initialValues.zip_code,
      is_disabled: initialValues.is_disabled,
      country: initialValues.country,
      channel: initialValues.channel || "passive",
      sale_owner_id: initialValues.sale_owner_id || 0,
      note: "",
      is_postpaid,
      payment_term,
      min_balance_allowed,
      priority: initialValues.priority,
      notify_email: initialValues.notify_member.email || [initialValues.email],
      notify_balance:
        initialValues.notify_member.balance > 0
          ? initialValues.notify_member.balance
          : null,
    });

    this.setState({ userDetail: initialValues });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return;
      }
      this.props.onSave(values);
    });
  };

  isDisabledIsPostpaid = () => {
    const is_postpaid = this.props.detail.is_postpaid;
    return is_postpaid === 2;
  };
  onChangeIsPostpaid = (value) => {
    const is_postpaid = value === 2;
    if (!is_postpaid) {
      this.props.form.setFieldsValue({
        payment_term: undefined,
        min_balance_allowed: undefined,
      });
    }
  };

  isDisablePaymentTerm = () => {
    const is_postpaid = this.props.form.getFieldValue("is_postpaid");
    return is_postpaid === 1;
  };
  isRequiredPaymentTerm = () => {
    const is_postpaid = this.props.form.getFieldValue("is_postpaid");
    return is_postpaid === 2;
  };

  isDisableMinBalanceAllowed = () => {
    const is_postpaid = this.props.form.getFieldValue("is_postpaid");
    return is_postpaid === 1;
  };
  isRequiredMinBalanceAllowed = () => {
    const is_postpaid = this.props.form.getFieldValue("is_postpaid");
    return is_postpaid === 2;
  };

  render() {
    const { isAddUser, isReqSalesBinding } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Form id="userDetail" {...formItemLayout} onSubmit={this.handleSubmit}>
        <Form.Item label="Email">
          {getFieldDecorator("email", {
            rules: [
              {
                type: "email",
                message:
                  "Please input the email correct the format e.g. exampla@mail.com",
              },
              {
                required: true,
                message: "Please input the email",
              },
            ],
          })(
            <Input
              disabled={isReqSalesBinding}
              placeholder="e.g. example@mail.com"
            />,
          )}
        </Form.Item>
        <Form.Item label="First Name">
          {getFieldDecorator("firstname", {
            rules: [
              {
                required: true,
                message: "Please input the firstname",
                whitespace: true,
              },
            ],
          })(<Input disabled={isReqSalesBinding} />)}
        </Form.Item>
        <Form.Item label="Last Name">
          {getFieldDecorator("lastname", {
            rules: [
              {
                required: true,
                message: "Please input the lastname",
                whitespace: true,
              },
            ],
          })(<Input disabled={isReqSalesBinding} />)}
        </Form.Item>
        <Form.Item label="Country">
          <Row gutter={6}>
            <Col span={12}>
              {getFieldDecorator("country", {
                rules: [{ required: true, message: "Please choose country" }],
              })(
                <Select
                  disabled={isReqSalesBinding}
                  placeholder="Choose country"
                  getPopupContainer={() =>
                    document.getElementById("userDetail")
                  }
                >
                  {this.state.countryList.map((v, i) => (
                    <Select.Option key={v.id} value={v.region_code}>
                      {v.name}
                    </Select.Option>
                  ))}
                </Select>,
              )}
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="Mobile Phone">
          {getFieldDecorator("tel")(
            <Input
              style={{ width: "100%" }}
              disabled={isReqSalesBinding}
              placeholder="e.g. 66878912345"
            />,
          )}
        </Form.Item>
        <Form.Item label="Company Name">
          {getFieldDecorator("company_name", {
            rules: [{ whitespace: true }],
          })(<Input disabled={isReqSalesBinding} />)}
        </Form.Item>
        <Form.Item label="Address">
          {getFieldDecorator("address", {
            rules: [{ whitespace: true }],
          })(<Input disabled={isReqSalesBinding} />)}
        </Form.Item>
        <Form.Item label="City">
          {getFieldDecorator("city", {
            rules: [{ whitespace: true }],
          })(<Input disabled={isReqSalesBinding} />)}
        </Form.Item>
        <Form.Item label="State">
          {getFieldDecorator("state", {
            rules: [{ whitespace: true }],
          })(<Input disabled={isReqSalesBinding} />)}
        </Form.Item>
        <Form.Item label="Zip Code">
          <Row gutter={6}>
            <Col span={12}>
              {getFieldDecorator("zip_code")(
                <Input disabled={isReqSalesBinding} />,
              )}
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="Priority">
          <Row gutter={6}>
            <Col span={12}>
              {getFieldDecorator("priority", {
                rules: [
                  {
                    validator: (rule, value, callback) => {
                      if (!value) {
                        return callback();
                      }
                      const num = Number(value);
                      if (Number.isNaN(num) || num < 1 || num > 10) {
                        callback("Please input a number between 1-10");
                      } else {
                        callback();
                      }
                    },
                  },
                ],
              })(<Input type="number" />)}
            </Col>
          </Row>
        </Form.Item>

        <Divider>
          <Text strong>Payment</Text>
        </Divider>
        <Form.Item label="Payment Type">
          {getFieldDecorator("is_postpaid", {
            rules: [
              {
                required: true,
                message: "Please choose payment type",
              },
            ],
          })(
            <Select
              disabled={isReqSalesBinding || this.isDisabledIsPostpaid()}
              placeholder="Choose Payment Type"
              getPopupContainer={() => document.getElementById("userDetail")}
              onChange={this.onChangeIsPostpaid}
            >
              <Select.Option value={1} key="is_postpaid-1">
                Prepaid
              </Select.Option>
              <Select.Option value={2} key="is_postpaid-2">
                Postpaid
              </Select.Option>
            </Select>,
          )}
        </Form.Item>
        <Form.Item label="Payment Term">
          {getFieldDecorator("payment_term", {
            rules: [
              {
                required: this.isRequiredPaymentTerm(),
                message: "Please choose payment term",
              },
            ],
          })(
            <Select
              disabled={isReqSalesBinding || this.isDisablePaymentTerm()}
              placeholder="-"
              getPopupContainer={() => document.getElementById("userDetail")}
            >
              <Select.Option value={7} key="payment_term-1">
                7 days
              </Select.Option>
              <Select.Option value={15} key="payment_term-2">
                15 days
              </Select.Option>
              <Select.Option value={30} key="payment_term-3">
                30 days
              </Select.Option>
              <Select.Option value={60} key="payment_term-4">
                60 days
              </Select.Option>
            </Select>,
          )}
        </Form.Item>
        <Form.Item label="Minimum Balance">
          {getFieldDecorator("min_balance_allowed", {
            rules: [
              {
                required: this.isRequiredMinBalanceAllowed(),
                message:
                  "Please enter a minimum balance allowed. It should be between -10,000 and 0.",
              },
              {
                validator: (rule, value, cb) => {
                  if (!this.isRequiredMinBalanceAllowed())
                    return Promise.resolve();

                  if (!value) return Promise.reject();

                  const val = +value;
                  if (val < -10000 || val > 0)
                    return Promise.reject(
                      "Please enter a value between -10,000 and 0.",
                    );

                  const hasFourDecimalPlaces = (v) =>
                    /^-?\d*\.?\d{0,4}$/.test(v);
                  if (!hasFourDecimalPlaces(value))
                    return Promise.reject(
                      "Please enter a value with up to 4 decimal places.",
                    );

                  return Promise.resolve();
                },
              },
            ],
          })(
            <Input
              type="number"
              placeholder="-"
              disabled={isReqSalesBinding || this.isDisableMinBalanceAllowed()}
            />,
          )}
        </Form.Item>

        {(isAddUser || isReqSalesBinding) && (
          <div>
            <Divider>
              <Text strong>Sales Owner</Text>
            </Divider>
            <Form.Item label="Sales Owner">
              {getFieldDecorator("sale_owner_id", {
                rules: [
                  {
                    required: isReqSalesBinding,
                    message: "Please choose Sales Owner",
                  },
                  {
                    validator: (rule, value, callback) => {
                      if (isReqSalesBinding && value === 0) {
                        callback("Please choose Sales Owner");
                      } else {
                        callback();
                      }
                      return;
                    },
                  },
                ],
              })(
                <Select
                  onChange={this.handleChange}
                  getPopupContainer={() =>
                    document.getElementById("userDetail")
                  }
                >
                  <Select.Option value={0}>No Sales Owner</Select.Option>
                  {this.state.adminList.map((item, idx) => (
                    <Select.Option value={item.id} key={idx}>
                      {item.firstname + " " + item.lastname} ({item.email})
                    </Select.Option>
                  ))}
                </Select>,
              )}
            </Form.Item>

            <Form.Item label="Channel">
              {getFieldDecorator("channel")(
                <Select
                  disabled={
                    isAddUser &&
                    this.props.form.getFieldValue("sale_owner_id") === 0
                  }
                  getPopupContainer={() =>
                    document.getElementById("userDetail")
                  }
                >
                  <Select.Option value={"active"}>Active</Select.Option>
                  <Select.Option value={"passive"}>Passive</Select.Option>
                </Select>,
              )}
            </Form.Item>

            <Form.Item label="Note">
              {getFieldDecorator("note", {
                rules: [
                  {
                    max: 300,
                    message: "ใส่ข้อความได้สูงสุด 300 ตัวอักษร!",
                  },
                ],
              })(
                <TextArea
                  disabled={
                    isAddUser &&
                    this.props.form.getFieldValue("sale_owner_id") === 0
                  }
                  rows={4}
                />,
              )}
            </Form.Item>
          </div>
        )}
        <Divider>
          <Text strong>Member's Notification</Text>
        </Divider>
        <Form.Item label="Email">
          {getFieldDecorator("notify_email", {
            rules: [
              {
                validator: (rule, value, callback) => {
                  if (value) {
                    const invalidEmails = value.filter(
                      (email) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
                    );
                    if (invalidEmails.length > 0) {
                      callback(
                        `Invalid email format for: ${invalidEmails.join(", ")}`,
                      );
                      return;
                    }
                  }
                  callback();
                },
              },
            ],
          })(
            <Select
              mode="tags"
              style={{ width: "100%" }}
              dropdownStyle={{ display: "none" }}
              placeholder={this.props.form.getFieldValue("email")}
              tokenSeparators={[",", " "]}
              getPopupContainer={() => document.getElementById("userDetail")}
            />,
          )}
        </Form.Item>
        <Form.Item label="Balance Threshold">
          {getFieldDecorator("notify_balance")(
            <Input type="number" placeholder={"30"} />,
          )}
        </Form.Item>
      </Form>
    );
  }
}

const UserDetail = Form.create({ name: "member_detail" })(MemberDetail);

export default UserDetail;



// WEBPACK FOOTER //
// ./src/containers/User/user-detail.js